module.exports = __webpack_public_path__ + "img/referer_mint.8073637d.svg";